import { render, staticRenderFns } from "./YHFooter.vue?vue&type=template&id=c60b0fe0&"
import script from "./YHFooter.vue?vue&type=script&lang=js&"
export * from "./YHFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/test-e-youhuo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c60b0fe0')) {
      api.createRecord('c60b0fe0', component.options)
    } else {
      api.reload('c60b0fe0', component.options)
    }
    module.hot.accept("./YHFooter.vue?vue&type=template&id=c60b0fe0&", function () {
      api.rerender('c60b0fe0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/YHFooter.vue"
export default component.exports